import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Badge from './ui/Badge';
import { projects } from '../data/projects';

const Wrapper = styled.div`
  margin-top: clamp(2rem, 4vw, 2.75rem);
  padding-top: 1.5rem;
  border-top: 1px solid var(--border);
`;

const Label = styled.p`
  font-size: var(--fs-eyebrow);
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-3);
  margin-bottom: 0.85rem;
`;

const List = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`;

const Item = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 64px;
  padding: 0.5rem 0.75rem 0.5rem 0.5rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--surface);
  transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: var(--surface-hover);
    border-color: var(--border-strong);
    transform: translateY(-2px);
  }

  img {
    width: 64px;
    height: 40px;
    object-fit: cover;
    object-position: top;
    border-radius: 6px;
    border: 1px solid var(--border);
    flex-shrink: 0;
  }
`;

const Text = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3rem;
  min-width: 0;
`;

const Name = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-1);
  line-height: 1.2;
`;

const WorkStrip: React.FC = () => (
  <Wrapper>
    <Label id="recent-work-label">Recent work</Label>
    <List aria-labelledby="recent-work-label">
      {projects.map((project) => (
        <li key={project.slug}>
          <Item to={`/projects#${project.slug}`}>
            <img src={project.images.card.src} alt="" width={64} height={40} decoding="async" />
            <Text>
              <Name>{project.name}</Name>
              <Badge variant={project.status} />
            </Text>
          </Item>
        </li>
      ))}
    </List>
  </Wrapper>
);

export default WorkStrip;
